import { render, staticRenderFns } from "./giftActivityList.vue?vue&type=template&id=5a8974cf&scoped=true"
import script from "./giftActivityList.vue?vue&type=script&lang=js"
export * from "./giftActivityList.vue?vue&type=script&lang=js"
import style0 from "./giftActivityList.vue?vue&type=style&index=0&id=5a8974cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8974cf",
  null
  
)

export default component.exports